import React from 'react';
import { useStyletron } from 'baseui';
import { formatStructuredAnswer } from '../../utils/formatStructuredAnswer';
import { renderInlineMarkdown } from '../../utils/renderInlineMarkdown';

const FormattedAnswer = ({ item }) => {
  const [, theme] = useStyletron();
  const formatted = formatStructuredAnswer(item.answer);

  return (
    <span style={{ whiteSpace: 'pre-wrap', lineHeight: 1.55 }}>
      {renderInlineMarkdown(formatted, theme)}
    </span>
  );
};

export default FormattedAnswer;
